import styled from '@emotion/styled';

const CheckoutButtonWrap = styled('div')({
  height: '5rem',
  margin: '3.5rem auto',
  width: '15.6rem',
});

export default CheckoutButtonWrap;
